
export enum CampaignType {
    ANNIVERSARY = 'ANNIVERSARY',
    BIRTHDAY = 'BIRTHDAY',
    CLOSED_LOAN = 'CLOSED_LOAN',
    EPO = 'EPO',
    TBD = 'TBD',
    OPPORTUNITY_SUMMARISING = 'OPPORTUNITY_SUMMARISING'
}

export const ALL_CAMPAIGN_TYPES = ():CampaignType[] => {
    let types = [];
    for (let campaign in CampaignType) {
        types.push(campaign);
    }
    return types;
};
